import { call, put } from "redux-saga/effects";
import { Types } from "../reducers/userReducer";

import api from "services/api";

export function* userChangePageSaga(action) {
  let response;
  let data;

  try {
    response = yield call(() => {
      return api().get(
        `users?page=${action.page + 1}&perPage=${action.perPage}`,
        {
          params: action.search
        }
      );
    });

    data = response.data;

    yield put({ type: Types.USER_CHANGE_PAGE_SUCCESS, data });
  } catch (error) {
    console.tron.log(error.response);
    if (error.response.status === 404) {
      data = { message: "Falha na tentativa de listar os usuários" };
    } else {
      data = error.response.data;
    }

    yield put({ type: Types.USER_CHANGE_PAGE_FAILURE, data });
  }
}
